import React, { useRef, useState, useEffect } from "react";
import EmployeeLayout from "../../../layout/EmployeeLayout";
import strings from '../../../translation';
import { useSelector, useDispatch } from "react-redux";
import ReactPlayer from 'react-player';
import SignatureCanvas from 'react-signature-canvas';
import './signatureStyle.css';
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom"

const TrainingVideo = () => {
  const videoRef = useRef(null);
  const signatureRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [isVideoCompleted, setIsVideoCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [signatureURL, setSignatureURL] = useState(null);
  const history = useHistory()

  const [loading, setLoading] = useState(false);

  const user = useSelector(state => state.login.loginInfo)

  const location = useLocation();
  const { jobSite } = location.state || {}; 

  const video = useSelector(state => state.employeeHome.video);
  const signatureStatus = useSelector(state => state.employeeHome.signatureStatus);
  const signatureRequesting = useSelector(state => state.employeeHome.signatureRequesting);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "GET_VIDEO" });
  }, []);

  useEffect(() => {
    if (video && video.length > 0) {
      dispatch({ type: 'SIGNATURE_STATUS', id: video[0]?.id, meeting_id: video[0]?.meetings[0] });
    }
  }, [video,signatureRequesting]);

  useEffect(()=>{
    setLoading(false)
    if(signatureStatus){
      history.push({
        pathname: "/employee/quiz",
        state: { id: video[0]?.id, meeting_id: video[0]?.meetings[0] }
      })
    }
  }, [signatureStatus])

  const handleEnded = () => {
    setIsVideoCompleted(true);
    setShowModal(true); // Open modal on video end
  };

  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleSubmitSignature = () => {
    const isEmpty = signatureRef.current.isEmpty()
    if (isEmpty) {
      alert(strings.PLEASE_ADD_YOUR_SIGNATURE_FIRST);
      return;
    } 
    const dataURL = signatureRef.current.toDataURL();
    console.log(user.users.employee_company_detail[0].company);
    setLoading(true);
    const data = {
      video_id: video[0]?.id,
      jobsite_id: jobSite?.id,
      company_id: user?.users?.employee_company_detail[0].company,
      meeting_id:video[0]?.meetings[0],
      signature: dataURL
    }
    dispatch({
      type: "SIGNATURE",
      data: data,
      id: video[0]?.id,
      meeting_id: video[0]?.meetings[0],
    })
    
  };

  return (
    <EmployeeLayout isActive={strings.HOME}>
      <div className="company-home-section">
        {video && video.length > 0 && (
          <div className="video-container">
            <ReactPlayer
              ref={videoRef}
              url={video[0]?.video}
              playing={!paused}
              controls
              width="100%"
              
              onEnded={handleEnded}
            />
          </div>
        )}

        {video && video.length == 0 && ( <div className="no-jobsite-message">
                    {strings.NO_VIDEO_FOR_TODAY}
         </div>)}

        {/* Modal */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h5> {strings.ADD_SIGNATURE}</h5>
              <SignatureCanvas
                ref={signatureRef}
                canvasProps={{ width: 500, height: 200, className: 'signatureCanvas' }}
              />
              <div className="button-row">
                <button style={{ backgroundColor: loading ? '#FCD329' : '#FED200'}} className="modal-submit" onClick={handleSubmitSignature} 
                  disabled={loading }
                  >
                  {strings.SUBMIT}
                </button>
                <button className="modal-clear"  onClick={handleClear}>
                  {strings.CLEAR}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Preview (Optional) */}
        {signatureURL && (
          <div style={{ marginTop: 30 }}>
            <h4>Signature Preview:</h4>
            <img src={signatureURL} alt="Signature" style={{ border: '1px solid #000' }} />
          </div>
        )}
      </div>
    </EmployeeLayout>
  );
};

export default TrainingVideo;
